// extracted by mini-css-extract-plugin
export default {"heading":"index_heading__vLCDe","secHead":"index_secHead__Cf9ni","simpleHeading":"index_simpleHeading__4Jxsi","simpleParagraph":"index_simpleParagraph__OrOpL"};